/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import { PermissionAddModal } from './PermissionAddModal'
import { propTypes } from 'react-bootstrap/esm/Image';
import { Auth } from 'aws-amplify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

type Props = {
  className : string,
  permissions : any,
  getAllPerm : any
}

const PermissionTable: React.FC<Props> = ({className, permissions, getAllPerm}) => {

    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null);
    const [edit, setEdit] = useState(false);

    const toggleShow = (permissionId:any)  => {
        
        setEdit(false);
        if(permissionId !== 0){
          setEdit(true);
          permissions.map((permission:any)=> {
            if(permissionId === permission.id){
              setData(permission);
            }
          });
        
        }

        //console.log('toggleShow ' + permissionId)
        setShowModal(pre => !pre);

        if(showModal){
          console.log('toggleShow ' + permissionId);
          getAllPerm();
        }
    }

    const deletePermission = async (permissionId:any) => {
      //delete permission

        try
        {

          confirmAlert({
            title: 'Confirm',
            message: 'Are you sure, you want to delete?',
            buttons: [
              {
                label: 'Yes',
                onClick: async () => {

                  const auth = await Auth.currentSession();
                  const token = auth.getAccessToken().getJwtToken();
      
                  await fetch(process.env.REACT_APP_API_URL_BACKEND + '/permission/', 
                  {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                    body: JSON.stringify({'permission_id': permissionId})
                  });
                  
                  getAllPerm();
                }
              },
              {
                label: 'No',
                onClick: () => {}
              }
            ]
          });

        }
        catch(error)
        {
          console.log(error);
        }
  

    }

  return (
    <>
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Permissions</span>
        </h3>
        <div className='card-toolbar'>
          <button onClick={() => toggleShow(0)} className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add Permissions
          </button>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-325px rounded-start'>Name</th>
                <th className='min-w-200px text-end rounded-end'></th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
                {permissions.map((permission:any) => (
                    <tr key={`permission-${permission.id}`}>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{permission.name}</span></td>
                        <td className='text-end'>
                            <a href='#' onClick={() => toggleShow(permission.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            <a href='#' onClick={() => deletePermission(permission.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                            </a>
                        </td>
                    </tr>
                )
                )}


            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
    {
        showModal ? <PermissionAddModal toggleShow={toggleShow} isUpdate={edit} itemToEdit={data} /> : null
    }
    </>
  )
}

export {PermissionTable}
